module.exports = __webpack_public_path__ + "img/welfare-coupon.f3622829.png";